import React, { useContext, useMemo } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import MyWorkContext from '@totem/components/users/myWork/MyWorkContext';
import MyWorkLayout, {
  MyWorkExtra,
} from '@totem/components/users/myWork/MyWorkLayout';
import { isNull } from '@totem/utilities/common';

const MyWorkConditionalPanel = () => {
  const { data } = useContext(MyWorkContext);

  const hasWork = useMemo(() => {
    if (isNull(data)) {
      return false;
    }

    return data.length > 0;
  }, [data]);

  if (hasWork) {
    return (
      <IBCard isCovered title={'My Work'} extra={<MyWorkExtra />}>
        <MyWorkLayout />
      </IBCard>
    );
  }

  return null;
};

export default MyWorkConditionalPanel;
